import { Component, OnInit, Input } from '@angular/core';
import { ReportService } from '@app/core';
import { filter } from '../../../../node_modules/rxjs-compat/operator/filter';

@Component({
  selector: 'app-blockedcolumnchart',
  templateUrl: './blockedcolumnchart.component.html',
  styleUrls: ['./blockedcolumnchart.component.scss']
})
export class BlockedcolumnchartComponent implements OnInit {
  @Input() filterData: any;
  columnNames = ['This Month', 'Account Monitoring Job', 'Login'];

  data = [
    ['2004', 1000, 400],
    ['2005', 1170, 460],
    ['2006', 660, 1120],
    ['2007', 1030, 540]
  ];

  options = {
    legend: { position: 'bottom' }
  };

  constructor(private reportService: ReportService) { }
  ngOnChanges() {
    console.log(this.filterData);
    this.getBlockColumn(this.filterData);
  }

  ngOnInit() {
    console.log(this.filterData);
    this.getBlockColumn("Today");
  }

  getBlockColumn(filter: string) {
    this.reportService.getRegisteredVSBlockedAnalyticsData(filter).subscribe(
      response => {
        console.log(response.data);
        this.data = response.data
      },
      error => {
      }
    )
  }
}
